import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-ink text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <Logo className="w-14 h-14" />
              <div>
                <div className="font-serif text-2xl tracking-tight">Front Uni pour la RDC</div>
                <div className="eyebrow eyebrow-on-dark mt-1">Plateforme officielle</div>
              </div>
            </div>
            <p className="mt-6 text-white/75 leading-relaxed max-w-md text-[0.95rem]">
              Plateforme institutionnelle de la diaspora congolaise. Plaidoyer international, solidarité,
              information et mobilisation au service de la République démocratique du Congo.
            </p>
            <div className="divider-gold w-24 mt-8" />
            <div className="mt-6 space-y-2 text-white/70 text-sm">
              <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-gold" /> Diaspora · International</div>
              <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> <a href="mailto:contact@frontunirdc.be" className="hover:text-gold" data-testid="footer-contact-email">contact@frontunirdc.be</a></div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow eyebrow-on-dark mb-5">Plateforme</div>
            <ul className="space-y-3 text-white/80 text-sm">
              {[
                ["/organisation", "Organisation"],
                ["/evenements", "Événements"],
                ["/actualites", "Actualités"],
                ["/medias", "Médias"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}><Link to={to} className="hover:text-gold transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="eyebrow eyebrow-on-dark mb-5">Médias</div>
            <ul className="space-y-3 text-white/80 text-sm">
              <li><Link to="/web-tv" className="hover:text-gold transition-colors">Web TV</Link></li>
              <li><Link to="/radio" className="hover:text-gold transition-colors">Radio</Link></li>
              <li><Link to="/conferences" className="hover:text-gold transition-colors">Conférences</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="eyebrow eyebrow-on-dark mb-5">Accès</div>
            <ul className="space-y-3 text-white/80 text-sm">
              <li><Link to="/membres/connexion" className="hover:text-gold transition-colors flex items-center gap-1">Espace membres <ArrowUpRight className="w-3.5 h-3.5" /></Link></li>
              <li><Link to="/admin/connexion" className="hover:text-gold transition-colors flex items-center gap-1">Administration <ArrowUpRight className="w-3.5 h-3.5" /></Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/55">
          <div>© {new Date().getFullYear()} Front Uni pour la RDC. Tous droits réservés.</div>
          <div className="flex items-center gap-5">
            <span>RGPD</span><span>Mentions légales</span><span>Politique de confidentialité</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
